import React, { Component } from 'react';
import moment from 'moment';
import ProductsHelper from '../components/ProductsHelper'
import Config from '../Config'
import ContactPersons from '../components/ContactPersons'
import GeneralPractitioner from '../components/GeneralPractitioner';
import CustomerInfo from '../components/CustomerInfo'
import Validate from '../components/Validate';
import CheckItem from '../components/CheckItem';
import Protocol from '../components/Protocol'
import Products from '../components/Products';
import Accessories from '../components/Accessories';
import toast, {Toaster} from 'react-hot-toast';
import './css/actions.css'


class Actions extends Component {
    constructor(props) {
        super(props);


        this.bp = this.props.current.serviceCall.businessPartner;
        this.changes = this.props.changes;



        // initialize the products  (combination of original products + changes)
        const products = ProductsHelper.Get(this.props.current.orders, this.changes.state);

        // initialize the current PA and SK with the original values + changes
        this.initEquipmentState();

        // get the original businesspartner MBcode, or the changed values if they exist
        var mbcode1 = this.changes.state.mbcode1 ?? this.bp.reportingCenterCode1;
        var mbcode2 = this.changes.state.mbcode2 ?? this.bp.reportingCenterCode2;

        var process = this.props.current.processes;
        var savedData = {};
        if (process && process.length > 0) {
            savedData = process[0].changes;
        }

        this.state = {
            pa: this.pa,
            sk: this.sk,
            enableSave: props.current.isFirstSave,
            testSeconds: savedData.testSeconds > 0 ? savedData.testSeconds :
                this.changes.state.testSeconds > 0 ? this.changes.state.testSeconds : 0,
            emergencyCenter: (this.changes.state.emergencyCenter !== null ?
                this.changes.state.emergencyCenter :
                this.props.current.serviceCall.businessPartner.emergencyCenter.code),
            paInput: "",
            skInput: "",
            mbcode1: mbcode1,
            mbcode2: mbcode2,
            resolution: this.props.changes.state.resolution ? this.props.changes.state.resolution : this.props.current.serviceCall.resolution,
            timeStart: this.writeTime(this.props.changes.state.timeStart),
            products: products,
            linetest: this.props.changes.state.linetest ? this.props.changes.state.linetest : savedData.lineTest === true,
            alarmcall: this.props.changes.state.alarmcall ? this.props.changes.state.alarmcall : savedData.alarmCall === true,
            validdata: this.props.changes.state.validdata ? this.props.changes.state.validdata : savedData.validData === true,
            pstnInstalled: this.props.changes.state.hasOwnProperty("pstnInstalled") && this.props.changes.state.pstnInstalled!==null ? this.props.changes.state.pstnInstalled : "",
            keyPlaced: this.props.changes.state.hasOwnProperty("keyPlaced") && this.props.changes.state.keyPlaced!==null ? this.props.changes.state.keyPlaced : "",
            accordionMain: "devices",
            accordionProducts: "devices",
            activityAdded: false,
            mode: "",
            stockAlert: null,
            isExchange : this.props.current.serviceCall.changeArcCode!=="" || this.props.current.serviceCall.changeDeviceCode2!==""
        }

        console.log("Initialized state",  this.state);
    }

    componentDidMount() {
        // important: after initializing state, init the protocol
        // initialize the protocol  (show the protocol for current MC + MB code)
        this.initProtocol();

    }

    initEquipmentState() {
        // get the current equipment
        this.pa = [];
        this.sk = [];
        if (this.props.current.equipmentCards) {
            this.pa = this.props.current.equipmentCards.filter(p => p.item && !p.item.isHomeAccess);
            this.sk = this.props.current.equipmentCards.filter(p => !(p.item && !p.item.isHomeAccess));
        }

        // process removed equipment
        this.props.changes.state.equipmentRemoved.map((item, idx) => {
            var index = this.pa.findIndex(p => p.number === item.number);
            if (index > -1 && !item.item.isHomeAccess) this.pa.splice(index, 1);

            index = this.sk.findIndex(p => p.number === item.number);
            if (index > -1 && item.item.isHomeAccess) this.sk.splice(index, 1);
            return true;
        });

        // process added equipment
        const pa = [...this.pa, ...this.props.changes.state.equipmentAdded.filter(p => p.item && !p.item.isHomeAccess)];
        const sk = [...this.sk, ...this.props.changes.state.equipmentAdded.filter(p => !(p.item && !p.item.isHomeAccess))];

        // process modified equipment  (must be done after "add", can only be SK)
        this.props.changes.state.equipmentModified.map((item, idx) => {
            var skItem = this.sk.find(p => p.number === item.number);
            if (item.keySafeCode !== null) skItem.keySafeCode = item.keySafeCode;
            if (item.workInformation !== null) skItem.workInformation = item.workInformation;
            return true;
        });
        this.pa = pa;
        this.sk = sk;

    }

    initProtocol() {
        console.log("init protocol");
        Protocol.Init(this.state.emergencyCenter, this.state.mbcode1, this.state.mbcode2, p => {
            this.setState({ protocol: p });
        });

    }

    writeTime(n) {
        return moment(n).format('HH:mm')
    }


    textareaFocus(evt) {
        this.textareaResize(evt);
    }
    textareaResize(evt) {
        evt.target.style.height = 0;  // autoshrink
        evt.target.style.height = (evt.target.scrollHeight + 2) + "px";    // autogrow
    }

    handleChange(evt) {
        const name = evt.target.name;
        const value = evt.target.value;

        if (name === "resolution") {
            this.textareaResize(evt);
        } else if (name === "keyPlaced") {

            var text = "Let op: er moet nog een sleutel in de sleutelkluis";
            if (value === "3" && this.state.resolution.indexOf(text) === -1) {
                // add line to "werkzaamheden"
                this.changes.AppendResolution(text);
                this.resolutionUpdated();

                var details = "Sleutel nog te plaatsen in sleutelkluis klant " + this.props.current.serviceCall.businessPartner.cardCode;
                var notes = "De monteur heeft geen sleutel achtergelaten in sleutelkluis, en de PAO is middels een email geinformeerd";
                this.props.changes.AddActivityNote(details, notes);
            }

        } else if (name==="listCode") {
            this.setState({ listCode:value, changeDeviceCodeMessage : null, enableSaveDeviceCode: value!==null && value!== ""});

            // lookup the meldcode to check if it was changed
            var center=this.props.deviceCodeLists.find(p => p.code === value);
            
            if (center !== null && center.centreCode !== "" && this.state.emergencyCenter !== center.centreCode) {
                this.setState({ changeDeviceCodeMessage: "Let op, de meldcentrale zal hierdoor worden gewijzigd naar : " + center.centreCode + " (" + center.shortName + ")" });
            }
        }

        // when changing the mbcode (or prefix) that is active, then we want to oblige the user to choose another meldcentrale as well
        // this is independant of whether the emergencycenter has been emailed before
        if ((name === "mbcode1" || name === "mbcode2")) {
            this.setState({ emergencyCenter: "GEEN" });
            this.props.changes.Set("emergencyCenter", "GEEN");
        }



        this.setState({ [name]: value });
        this.props.changes.Set(name, value);
    }
    handleChangeBool(evt) {
        const name = evt.target.name;
        const value = evt.target.value === "true";

        this.setState({ [name]: value });
        this.props.changes.Set(name, value);
    }
    handleChangeCode(evt) {
        const kek = evt.target.name;
        const value = evt.target.value;

        this.props.changes.ModifyEquipmentCode(kek, value);

        this.initEquipmentState();
        this.setState({ pa: this.pa, sk: this.sk });

    }
    handleChangeWorkInformation(evt) {
        const kek = evt.target.name;
        const value = evt.target.value;

        this.props.changes.ModifyEquipmentWorkInformation(kek, value);

        this.initEquipmentState();
        this.setState({ pa: this.pa, sk: this.sk });

    }
    handleChangeTime(evt) {
        const name = evt.target.name;
        const value = evt.target.value;
        this.setState({ [name]: value, timeError: true });


        // parse the time from the value
        try {
            var els = value.split(":");
            if (els.length === 2 && els[0] !== "" && els[1] !== "" && els[0] >= 0 && els[1] >= 0 && els[0] <= 24 && els[1] <= 59 && els[1].length === 2) {
                var date = new Date();
                date.setHours(els[0], els[1]);

                this.props.changes.state[name] = date;  // save to the parent object
                this.setState({ timeError: false });
            }
        } catch (ex) {

        }
    }

    handleCheckbox(evt) {
        const name = evt.target.name;
        const value = evt.target.checked;
        this.setState({ [name]: value });
        this.props.changes.state[name] = value;  // save to the parent object
    }

    isValid(number, type) {
        if (number === "") {
            this.setState({ mode: "alert", message: "Er is geen geldige KEK of serienummer ingevoerd" });
            return false;
        }
        if (type === "bykek") {
            if (!(number > 0 && number <= 99999)) {
                this.setState({ mode: "alert", message: "Er is geen geldige KEK ingevoerd" });
                return false;
            }
        } else {
            if (number.length > 15) {
                this.setState({ mode: "alert", message: "Er is geen geldig serienummer ingevoerd" });
                return false;
            }
        }
        return true;
    }

    addPa(type) {
        const number = this.state.paInput;
        if (!this.isValid(number, type)) return;
        this.addEquipment(number, type, false);
    }

    addSk(type) {
        const number = this.state.skInput;
        if (!this.isValid(number, type)) return;
        this.addEquipment(number, type, true);
    }

    removePa(idx) {
        // check if this item was just added 
        var itemToRemove = this.state["pa"][idx];

        if (this.changes.state.equipmentAdded.find(p => p.number === itemToRemove.number)) {
            // return the equipment to active equipment of technician
            this.removeEquipment(idx, "pa", "A");
            // remove the PSTN status
            this.props.changes.state.pstnInstalled = false;
        } else {
            this.setState({ mode: "confirmRemove", removeIndex: idx, removeType: "pa" });
        }
    }


    removeSk(idx) {
        // check if this item was just added 
        var itemToRemove = this.state["sk"][idx];

        if (this.changes.state.equipmentAdded.find(p => p.number === itemToRemove.number)) {
            // return the equipment to active equipment of technician
            this.removeEquipment(idx, "sk", "A");
        } else {
            this.setState({ mode: "confirmRemove", removeIndex: idx, removeType: "sk" });
        }
    }

    removeConfirmed(newStatus) {
        this.removeEquipment(this.state.removeIndex, this.state.removeType, newStatus);
    }

    removeEquipment(idx, type, newStatus) {

        var itemToRemove = this.state[type][idx];

        // configure the new status of the item
        itemToRemove.status = newStatus;

        // check if this was previously added
        var addedItemIndex = this.props.changes.state.equipmentAdded.findIndex(p => p.number === itemToRemove.number);


        if (addedItemIndex > -1) {
            // remove from the added list
            this.props.changes.state.equipmentAdded.splice(addedItemIndex, 1);
            this.initEquipmentState();
            this.setState({ pa: this.pa, sk: this.sk });
            return;
        }

        var array = this.state[type];
        var item = array[idx];
        array.splice(idx, 1);                       // 2nd parameter means remove one item only

        // update the changes in the parent first
        this.props.changes.RemoveEquipment(item);

        // then restore the state
        this.initEquipmentState();

        // check if there no more PA
        if (this.pa.length === 0) {
            // there are no more PA devices, check that all devices are set to 0
            this.props.changes.SetAccessory("handzenders", 0);
            this.props.changes.SetAccessory("collierzenders", 0);
            this.props.changes.SetAccessory("rookmelder", 0);
            this.props.changes.SetAccessory("valdetector", 0);
            this.props.changes.SetAccessory("trekkoord", 0);
            this.props.changes.SetAccessory("deurcontact", 0);
            this.props.changes.SetAccessory("bewegingsmelder", 0);
        }

        this.setState({ pa: this.pa, sk: this.sk, mode: "" });
    }

    // add new equipment, type can be : "bykek" or "byserialnumber"
    addEquipment(number, type, isHomeAccess) {
        var currentItem = this.props.current.equipmentCards && this.props.current.equipmentCards.find(p => p.number === number);
        var addedItem = this.props.changes.state.equipmentAdded.find(p => p.number === number);
        var removedItem = this.props.changes.state.equipmentRemoved.find(p => p.number === number || p.serialNumber === number);
        if (removedItem) {
            // if previously removed, then undo this in the parent object
            console.log("previously removed, remove from removed");
            var idx = this.props.changes.state.equipmentRemoved.findIndex(p => p.number === number);
            this.props.changes.state.equipmentRemoved.splice(idx, 1);
            this.initEquipmentState();
            this.setState({ pa: this.pa, sk: this.sk, paInput: "", skInput: "" });

        } else if (currentItem) {
            // this item already exists, ignore
            this.setState({ mode: "alert", message: "Deze KEK is reeds geinstalleerd" });
            return;
        } else if (addedItem) {
            // if already added, ignore
            this.setState({ mode: "alert", message: "Deze KEK is reeds toegevoegd" });
            return;
        } else {
            // adding a new item, lookup the details

            // determine whether this is Buy or Rent for a keysafe
            const status = isHomeAccess && this.props.current.orders && this.props.current.orders.some(p => p.lines.some(l => l.item.isHomeAccess && l.item.isBuy)) ? "A" : "L";
            var newItem = { number: number, status: status, item: { name: "-", isHomeAccess: isHomeAccess }, isNew: true };
            this.props.changes.AddEquipment(newItem);


            var itemToUpdate = this.props.changes.state.equipmentAdded.find(p => p.number === number);
            console.log("itemToUpdate", itemToUpdate);

            const url = Config.DigibonServiceBase + "equipmentCards/" + number + "/" + type;
            console.log(url);
            fetch(url, Config.GetBearer())
                .then((res) => { return res.ok ? res.json() : { status: res.status } })
                .then((json) => {
                    if (json.status === 401) {
                        this.setState({ mode: "alert", message: "Het is noodzakelijk opnieuw in te loggen" });
                        return;
                    }
                    if (Config.isDev) console.log("kek info", json);

                    // found information, update it 
                    var foundItem = json.find(p => p.number === number || p.serialNumber === number);
                    console.log("founditem", foundItem);

                    console.log("Stock item belongs to ", foundItem.businessPartner.alias);
                    console.log("Changes are being made by  ", this.props.changes.technicianCode);
                    console.log("Selected user", this.props.selectedUser);

                    // check if there is a technician mismatch
                    if (foundItem.businessPartner.alias!== this.props.selectedUser) {
                        console.log("Identified stock of other technician!");
                        
                        this.setState({ stockAlert: true });
                    }

                    // check for invalid status
                    if (itemToUpdate && foundItem) {
                        // update the subscription codes and name

                        if (foundItem.status === "R") {
                            itemToUpdate.error = "Kek heeft geretourneerde status, kan niet opnieuw worden ingezet";
                        }
                        else if (foundItem.businessPartner.status === "Apparaat is geplaatst" ||
                            foundItem.businessPartner.status === "Retour aangevraagd") {
                            itemToUpdate.error = "Deze Kek is reeds geplaatst bij een actieve klant";
                        }
                        else if (foundItem.status === "L") {
                            itemToUpdate.error = "Kek heeft reeds geleende status";
                        }
                        else if (this.state.pa.length >= 1 && !foundItem.item.isHomeAccess) {
                            // we are adding a PA but there is already PA added
                            itemToUpdate.item = foundItem.item;
                            itemToUpdate.error = "Ongeldige situatie. Er kan maar 1 KEK voor personenalarm geselecteerd worden";
                        }
                        else {
                            itemToUpdate.number = foundItem.number;
                            itemToUpdate.item = foundItem.item;
                            itemToUpdate.serialNumber = foundItem.serialNumber;
                            itemToUpdate.internalSerialNumber = foundItem.internalSerialNumber;
                            itemToUpdate.subscriptionCodes = foundItem.subscriptionCodes;
                        }
                    } else {
                        itemToUpdate.error = "KEK niet gevonden";
                    }

                    // hardcoded:  when this is a "afstandsbediening" or "Sleutelkluis 5415D" or "Phoniro Main Entrance met contact (ME)", always make sure that this is "koop"
                    if (foundItem.item.code === "3242575" ||
                        foundItem.item.code === "1235415001" ||
                        foundItem.item.code === "MALO-BE-NL-INNO-001AA" ||
                        foundItem.item.code === "ME08T4" ||
                        foundItem.item.code === "ME08T6")
                    {
                        // this is an afstandsbediening, sleutelkluis 5415D or Phoniro
                        console.log("This article " + foundItem.item.code + " is always set to 'koop'");
                        itemToUpdate.status = 'A';
                    }

                    // when handzender was 0, set it to 1
                    if (this.pa.length > 0) {
                        this.props.changes.SetAccessory("handzenders", 1);
                    }

                    // update the view
                    this.initEquipmentState();
                    this.setState({ pa: this.pa, sk: this.sk, paInput: "", skInput: "" });

                    // additional check when requesting "Plaatsing Flexibel" and not adding PA-131, only when adding PA
                    if (this.props.current.serviceCall.problemType === 1 &&
                        this.props.current.serviceCall.problemSubType === 2 &&     // Flexibel
                        (foundItem.subscriptionCodes.indexOf("PA-131") === -1 || foundItem.internalSerialNumber==="") &&
                        !foundItem.item.isHomeAccess
                    ) {
                        // installing PA, we have a ServiceCall to install flexible, but we are not installing a GSM device
                        this.setState({ mode: "provideReasonForNotInstallingGSM", reason: "Reden omzetting van Flexibel abonnement naar Basis abonnement: " });
                    }

                    // additional check when requesting "Plaatsing Basis" (or Basis LAN) and adding PA-131, only when adding PA
                    if (this.props.current.serviceCall.problemType === 1 &&
                        (this.props.current.serviceCall.problemSubType === 1    // Basis 
                            || this.props.current.serviceCall.problemSubType === 38  // LAN
                        ) &&
                        foundItem.subscriptionCodes.indexOf("PA-131") > -1 &&
                        foundItem.internalSerialNumber!=="" &&
                        !foundItem.item.isHomeAccess
                    ) {
                        // installing PA, we have a ServiceCall to install basic, but we are installing a GSM device
                        this.setState({ mode: "provideReasonForInstallingGSM", reason: "Reden omzetting van Basis abonnement naar Flexibel abonnement: " });
                    }

                  

                }).catch((error) => {
                    itemToUpdate.error = "KEK niet gevonden";
                    // update the view
                    this.initEquipmentState();
                    this.setState({ pa: this.pa, sk: this.sk, paInput: "", skInput: "" });
                });
        }
    }

    showToggleSk(idx) {
        this.setState({ mode: "confirmToggleRent", skToToggle: idx, currentSkMode: this.sk[idx].status });
    }

    toggleSk() {
        var idx = this.state.skToToggle;

        // change state
        var sk = [...this.state.sk];
        var newStatus = sk[idx].status === "L" ? "A" : "L";
        sk[idx].status = newStatus;
        this.setState({ sk: sk, mode: "" });

        // make the change in the "changes" object
        this.props.changes.ChangeAddedEquipment(sk[idx].number, newStatus);
    }



    selectPredefinedText(evt) {
        var value = evt.target.value;

        var item = this.props.predefinedTexts.find(p => p.name === value);
        if (item) {
            this.props.changes.AppendResolution(item.text);
            this.resolutionUpdated();
        }
    }

    openTest() {
        this.setState({ mode: "testResponse" });
    }

    startTest() {
        this.props.changes.state.testStart = new Date();
        this.setState({ testSeconds: 0, testStarted: true });
        if (!this.testInterval) {
            this.testInterval = setInterval(() => {
                var seconds = this.state.testSeconds;
                seconds++;
                this.setState({ testSeconds: seconds });
            }, 1000);
        }
    }

    stopTest() {
        clearInterval(this.testInterval);
        this.setState({ testStarted: false });
        this.testInterval = null;

        this.props.changes.state.testSeconds = this.state.testSeconds;
    }

    selectAccordionMain(item) {
        this.setState({ accordionMain: item });
    }

    dataUnknown() {

        // add an activity with High priority for the helpdesk
        this.setState({ activityAdded: true });
        this.props.changes.AddActivityHelpdesk("Gegevens zijn onbekend");
    }

    closeStockAlert() {
        this.setState({ stockAlert: null });
    }

    goMain() {
        this.setState({ mode: "" });
    }

    toUpper(e) {
        e.target.value = e.target.value.toUpperCase()
    }
    resetMbCode() {
        this.props.changes.state.mbcode1 = null;
        this.props.changes.state.mbcode2 = null;
        this.props.changes.Set("emergencyCenter", null);
        this.setState({ mbcode1: this.bp.reportingCenterCode1, mbcode2: this.bp.reportingCenterCode2, emergencyCenter: this.bp.emergencyCenter.code }, this.initProtocol);
    }
    
    showDeviceCodeList() {
        this.setState({ mode: "showDeviceCodeList", enableSaveDeviceCode:false, listCode:"", newmbcode1:"''", newmbcode2:"",setManualDeviceCode:false, changeDeviceCodeMessage: null });
    }

    hasEmail() {
        return true;
    }

    closeProvideReason(activityDetails) {
        var notes = this.props.changes.state.reason;

        // add activity 
        if (!notes) notes = "Geen opmerking achtergelaten door monteur";
        this.props.changes.AddActivityNote(activityDetails, notes);

        // add to werkzaamheden
        this.props.changes.AppendResolution(notes);
        this.resolutionUpdated();
        this.goMain();
    }

    resolutionUpdated() {
        // resolution was changed, update the state
        this.setState({ resolution: this.props.changes.state.resolution });
    }

    setDeviceCode() {
        // make the changes and close the popup
        if (this.state.newmbcode2 === "" || this.state.newmbcode2 === null) {
            this.setState({ deviceCodeError:"Er moet een meldbankcode ingevuld worden"});
            return;
        }
        var center=this.props.deviceCodeLists.find(p => p.code === this.state.listCode);
        
        this.props.changes.Set("emergencyCenter", center.centreCode);
        this.props.changes.state.mbcode1 = this.state.newmbcode1;
        this.props.changes.state.mbcode2 = this.state.newmbcode2;
        this.setState({ mode: "", mbcode1: this.state.newmbcode1, mbcode2:this.state.newmbcode2, emergencyCenter: center.centreCode}, this.initProtocol);        
    }

    getAvailableDeviceCode() {
        // do a call to get a new code for the specified list
        const url = Config.DigibonServiceBase + "devicecodes/" + this.state.listCode + "/getnextavailable?username=" + this.props.changes.state.technicianName;

        fetch(url, Config.GetBearer())
          .then((res) => { return res.ok ? res.json() : { status: res.status } })
          .then((json) => {
            console.log("json", json);
            if (json.code) {
                // found a code, lookup the emergency center
                console.log(this.props.deviceCodeLists);
                var center=this.props.deviceCodeLists.find(p => p.code === json.listCode);
                
                if (center) {
                    // make the changes and close the popup
                    this.props.changes.Set("emergencyCenter", center.centreCode);
                    this.props.changes.state.mbcode1 = json.prefix;
                    this.props.changes.state.mbcode2 = json.code;
                    this.setState({ mode: "", mbcode1: json.prefix, mbcode2:json.code, emergencyCenter: center.centreCode}, this.initProtocol);
                } else {
                    alert ("Fout: center " + json.code + " is niet gevonden.");
                }
            } else {
                this.setState({ deviceCodeError:"Er is een fout opgetreden bij het ophalen van een nieuwe code."});
            }
          });

    }

    copyClipboard(str) {
        navigator.clipboard.writeText(str);
        toast(str + " is gecopieerd naar het klembord");
    }

    render() {

        const sc = this.props.current.serviceCall;
        var bp = this.bp;

        const paHeader = <b><div className="row">
            <div className="col">KEK</div>
            <div className="col">Omschrijving</div>
            {this.state.enableSave &&
                <div className="col-3">Actie</div>
            }
        </div></b>

        const pa = this.state.pa.map((item, index) => {
            const kek=item.number;
            const sn=item.serialNumber;
            return <div className="row" key={index}>
                <div className="col" >{kek} </div>
                <div className="col">
                    {item.error && <span className="text-danger">{item.error}</span>}
                    {!item.error && <span>{item.item.name}</span>}
                    {item.serialNumber && 
                        <div>s/n: &#160;
                            <span className="link clickable" onClick={() => {this.copyClipboard(sn)}} >
                                {sn}
                            </span>
                        </div>}
                    {item.internalSerialNumber && <div>GSM: {item.internalSerialNumber}</div>}
                </div>
                {this.state.enableSave &&
                    <div className="col-3"><button className="btn btn-danger mb-1" onClick={() => this.removePa(index)}>terugnemen</button></div>
                }
            </div>
        });


        const skHeader = <b><div className="row">
            <div className="col-md-2">KEK</div>
            <div className="col">Huur/Koop</div>
            <div className="col">Omschrijving</div>
            {this.state.enableSave &&
                <div className="col-3">Actie</div>
            }
        </div></b>

        const sk = this.state.sk.map((item, index) => {
            return <React.Fragment key={index}><div className="row" >
                <div className="col-md-2">{item.number}</div>
                <div className="col">
                    <div className={this.state.enableSave && item.isNew ? "link" : ""}
                        onClick={this.state.enableSave && item.isNew ? () => this.showToggleSk(index) : null}>
                        {item.status === "L" ? "huur" : "koop"}
                    </div>

                </div>


                <div className="col">
                    {item.error && <span className="text-danger">{item.error}</span>}
                    {!item.error && <React.Fragment>
                        <div>{item.item.name}</div>
                        {item.serialNumber &&
                            <div><i>s/n: {item.serialNumber}</i></div>
                        }
                    </React.Fragment>}

                </div>
                {this.state.enableSave &&
                    <div className="col-3"><button className="btn btn-danger mb-1" onClick={() => this.removeSk(index)}>terugnemen</button></div>
                }
            </div>
                <div className="row mb-4">
                    <div className="col-md-2">

                    </div>
                    <div className="col">
                        {this.state.enableSave &&           // do not show the keysafe code when re-opening
                            <React.Fragment>
                                <div><b>Code</b></div>
                                <div>
                                    <React.Fragment>
                                        <input className="form-control" name={item.number} value={item.keySafeCode} onChange={this.handleChangeCode.bind(this)} onInput={this.toUpper}></input>
                                        <Validate value={item.keySafeCode} type="code"></Validate>
                                    </React.Fragment>
                                </div>
                            </React.Fragment>
                        }
                        {(this.state.enableSave || item.workInformation) && <React.Fragment>
                            <div><b>Opmerking</b></div>
                            <div>
                                {this.state.enableSave &&
                                    <textarea className="form-control mb-2" name={item.number} value={item.workInformation ?? ""} onChange={this.handleChangeWorkInformation.bind(this)}></textarea>
                                }
                                {!this.state.enableSave &&
                                    <span>{item.workInformation}</span>
                                }
                            </div>
                        </React.Fragment>
                        }
                    </div>
                    <div className="col-3">

                    </div>

                </div>
            </React.Fragment>
        });





        const predefinedTextOptions =
            <React.Fragment>
                <option value="">Werkzaamheden</option>
                {this.props.predefinedTexts.filter(p => p.problemTypeId === sc.problemType && p.problemSubTypeId === sc.problemSubType).map((item, index) => {
                    return <option key={index} value={item.name}>{item.name}</option>
                })
                }


            </React.Fragment>

        return <div className=" mb-4">
            {this.state.stockAlert !== null &&
                <div>
                    <div className="message-back"></div>

                    <div className="message-front">
                        <button className="sticky-top btn btn-secondary mb-4 position-absolute top-0 end-0 mt-2 me-2" onClick={this.closeStockAlert.bind(this)}>
                            <i className="fa-sharp fa-solid fa-xmark"></i>
                        </button>

                        <p>Let op : deze KEK behoort niet tot de eigen voorraad !</p>
                    </div>
                </div>
            }
            {this.state.mode === "alert" && this.state.stockAlert === null && 
                <div>
                    <div className="message-back"></div>

                    <div className="message-front">
                        <button className="sticky-top btn btn-secondary mb-4 position-absolute top-0 end-0 mt-2 me-2" onClick={this.goMain.bind(this)}>
                            <i className="fa-sharp fa-solid fa-xmark"></i>
                        </button>

                        <p>{this.state.message}</p>
                    </div>
                </div>
            }

            {this.state.mode === "confirmToggleRent" &&
                <div>
                    <div className="message-back"></div>

                    <div className="message-front">
                        {this.state.currentSkMode === "L" &&
                            <p>Sleutelkluis type veranderen van huur naar koop ?</p>
                        }
                        {this.state.currentSkMode === "A" &&
                            <p>Sleutelkluis type veranderen van koop naar huur ?</p>
                        }

                        <button className="btn btn-secondary" onClick={p => this.setState({ mode: "" })}>annuleren</button>
                        <button className="ms-2 btn btn-primary" onClick={p => this.toggleSk()}>bevestigen</button>

                    </div>
                </div>
            }
            {this.state.mode === "confirmRemove" &&
                <div>
                    <div className="message-back"></div>

                    <div className="message-front">
                        <button className="sticky-top btn btn-secondary mb-4 position-absolute top-0 end-0 mt-2 me-2" onClick={this.goMain.bind(this)}>
                            <i className="fa-sharp fa-solid fa-xmark"></i>
                        </button>

                        <p>Geef aan of dit apparaat meteen weer inzetbaar wordt uit eigen voorraad, of retour gaat naar Leende</p>

                        <button className="btn btn-primary me-2" onClick={p => this.removeConfirmed("A")}>naar eigen voorraad</button>
                        <button className="btn btn-secondary me-2" onClick={p => this.removeConfirmed("R")}>retour naar Leende</button>


                    </div>
                </div>
            }
            {this.state.mode === "provideReasonForNotInstallingGSM" && this.state.stockAlert === null&&
                <div>
                    <div className="reason-back"></div>

                    <div className="reason-front">


                        <p>Er is een <b>Plaatsing Flexibel</b> aangevraagd, maar er wordt een KEK voor een Basis abonnement geinstalleerd. Geef hieronder de reden aan. Dit wordt
                            toegevoegd aan de werkzaamheden beschrijving:</p>

                        <textarea className="form-control mt-2" style={{ height: "100px" }} name="reason" onChange={this.handleChange.bind(this)} value={this.state.reason ?? ""}></textarea>
                        <button className="btn btn-secondary mt-2" onClick={p => this.closeProvideReason("Basis geinstalleerd ipv Flexibel")}>sluiten</button>

                    </div>
                </div>
            }
            {this.state.mode === "provideReasonForInstallingGSM" && this.state.stockAlert === null &&
                <div>
                    <div className="reason-back"></div>

                    <div className="reason-front">
                        <p>Er is een <b>Plaatsing Basis</b> aangevraagd, maar er wordt een KEK voor een Flexibel abonnement geinstalleerd. Geef hieronder de reden aan. Dit wordt
                            toegevoegd aan de werkzaamheden beschrijving:</p>

                        <textarea className="form-control mt-2" style={{ height: "100px" }} name="reason" onChange={this.handleChange.bind(this)} value={this.state.reason ?? ""}></textarea>
                        <button className="btn btn-secondary mt-2" onClick={p => this.closeProvideReason("Flexibel geinstalleerd ipv Basis")}>sluiten</button>

                    </div>
                </div>
            }
            {
                this.state.mode==="showDeviceCodeList" && 
                <>
                    <div className="test-response-back"></div>

                    <div className="test-response-front-small">
                        <button className="sticky-top btn btn-secondary mb-4 position-absolute top-0 end-0 mt-2 me-2" onClick={this.goMain.bind(this)}>
                            <i className="fa-sharp fa-solid fa-xmark"></i>
                        </button>

                        <h3>Meldbank code wijzigen</h3>

                        <div className="mt-4">
                            Huidige meldcentrale: {this.state.emergencyCenter}
                        </div>
                        <div className="mt-2">
                            Selecteer een lijst waarvoor een nieuwe meldbankcode moet worden ingesteld :
                        </div>
                        <div className="mt-2">
                            <select className="form-control" name="listCode" value={this.state.listCode} onChange={this.handleChange.bind(this)}>
                                <option value="">[maak een keuze]</option>
                                {this.props.deviceCodeLists && this.props.deviceCodeLists.map((item, index) => {
                                    return <option key={index} value={item.code}>{item.shortName} - {item.name}</option>
                                })}
                            </select>
                        </div>
                        {
                            this.state.changeDeviceCodeMessage && <div className="bg-danger text-white mt-2 mb-2">
                                {this.state.changeDeviceCodeMessage}
                            </div>
                        }
                        { false && <>
                        <div className="mt-4">
                            <label><input type="checkbox" onChange={(el) => { this.setState({ setManualDeviceCode: el.target.checked})}}/> handmatig een meldbank-code opgeven</label>
                        </div>
                        </>}
                        {
                            this.state.setManualDeviceCode && 
                            <>
                            <div  className="mt-2">
                                Geef hieronder de nieuwe meldbank code op
                            </div>
                            <div className="row mt-2">
                                    <div className="col-md-1">Prefix:</div>
                                    <div className="col-md-2">
                                        <select className="form-control" name="newmbcode1" value={this.state.newmbcode1} onChange={this.handleChange.bind(this)}>
                                            <option value="''"></option>
                                            <option value="A">A</option>
                                            <option value="AN">AN</option>
                                            <option value="B">B</option>
                                            <option value="BO">BO</option>
                                            <option value="BR">BR</option>
                                            <option value="C">C</option>
                                            <option value="CP">CP</option>
                                            <option value="CT">CT</option>
                                            <option value="DC">DC</option>
                                            <option value="E">E</option>
                                            <option value="N">N</option>
                                            <option value="O">O</option>
                                            <option value="P">P</option>
                                            <option value="R">R</option>
                                            <option value="RB">RB</option>
                                            <option value="RP">RP</option>
                                            <option value="S">S</option>
                                            <option value="ST">ST</option>
                                            <option value="TP">TP</option>
                                            <option value="TS">TS</option>
                                        </select></div>
                                    <div className="col-md-1">Code</div>
                                    <div className="col-md-3">
                                        <input className="form-control" name="newmbcode2" value={this.state.newmbcode2} onChange={this.handleChange.bind(this)}></input></div>
                                    <div className="col"></div>

                                </div>
                            </>
                        }
                        { this.state.enableSaveDeviceCode && !this.state.setManualDeviceCode &&  
                        <div className="mt-4">
                            {/* retrieve a new device code */}
                            <button className="btn btn-secondary" onClick={this.getAvailableDeviceCode.bind(this)}>nieuwe meldbankcode opvragen</button>
                        </div>
                        }
                        { this.state.enableSaveDeviceCode && this.state.setManualDeviceCode &&  
                        <div className="mt-2">
                            {/* manually set a specific device code */}
                            <button className="btn btn-secondary" onClick={this.setDeviceCode.bind(this)}>nieuwe meldbankcode instellen</button>
                        </div>
                        }
                        {
                            this.state.deviceCodeError &&
                            <div className="bg-danger text-white mt-2">
                                {this.state.deviceCodeError}
                            </div>

                        }
                    </div>
                </>
            }
            {
                this.state.mode === "testResponse" &&
                <div>
                    <div className="test-response-back"></div>

                    <div className="test-response-front">
                        <button className="sticky-top btn btn-secondary mb-4 position-absolute top-0 end-0 mt-2 me-2" onClick={this.goMain.bind(this)}>
                            <i className="fa-sharp fa-solid fa-xmark"></i>
                        </button>

                        Test reactietijd alarmcentrale
                        {!this.state.testStarted &&
                            <button className="btn btn-success ms-4" onClick={this.startTest.bind(this)}>Start</button>
                        }
                        {this.state.testStarted &&
                            <button className="btn btn-danger ms-4" onClick={this.stopTest.bind(this)}>Stop</button>
                        }
                        {
                            (this.state.testStarted || this.state.testSeconds > 0) &&
                            <span className="ms-4">{this.state.testSeconds} seconden</span>
                        }
                        <div className="row">
                            <div className="col">
                                <div className="bold">Contactpersonen:</div>
                                <div className="row mt-4">
                                    <ContactPersons bon={this.props.current} alarmOnly={true} changes={this.props.changes}></ContactPersons>
                                </div>
                            </div>
                            <div className="col">
                                <div className="bold">Bezoekadres:</div>
                                <CustomerInfo bp={bp} changes={this.props.changes}></CustomerInfo>

                                <GeneralPractitioner data={bp.generalPractitioner}></GeneralPractitioner>

                                <div className="mb-4">
                                    <div className="bold">Professionele alarmopvolging:</div>

                                    {bp.professionalAlarmFollowUp && bp.professionalAlarmFollowUp.name &&
                                        <React.Fragment>
                                            <div>{bp.professionalAlarmFollowUp.name}</div>
                                            {bp.professionalAlarmFollowUp.email &&
                                                <React.Fragment>
                                                    <i className="fa-solid fa-envelope"></i> {bp.professionalAlarmFollowUp.email}
                                                </React.Fragment>
                                            }
                                        </React.Fragment>
                                    }
                                    {!(bp.professionalAlarmFollowUp && bp.professionalAlarmFollowUp.name) &&
                                        <div>Niet bekend</div>
                                    }
                                </div>





                            </div>
                        </div>
                        {!this.state.testStarted && this.state.testSeconds > 0 && <React.Fragment>

                            {!this.state.activityAdded && !this.props.changes.state.activities.find(p => p.name === "Helpdesk" && p.action === "T") &&
                                <button className="btn btn-danger" onClick={this.dataUnknown.bind(this)}>Gegevens onbekend</button>
                            }
                            {
                                this.state.activityAdded && this.props.changes.state.activities.find(p => p.name === "Helpdesk" && p.action === "T") &&
                                <p className="text-success">Er wordt een nieuwe activiteit toegevoegd, zie tabblad <b>afsluiten</b></p>
                            }

                            <button className="btn btn-secondary ms-4" onClick={this.goMain.bind(this)}>sluiten</button>
                        </React.Fragment>
                        }
                    </div>
                </div>
            }
            {
                this.state.mode === "" && this.state.stockAlert === null && <React.Fragment>
                    {!this.state.enableSave &&
                        <p className="text-danger">Wijzigingen zijn niet meer mogelijk. Deze servicecall is reeds eerder opgeslagen.</p>
                    }

                    {this.state.enableSave &&
                        <div className="row">
                            <div className="col-auto ms-2 mt-2">Aanvang werkzaamheden <i className="fa-solid fa-clock"></i></div>
                            <div className="col-1" style={{ minWidth: '100px' }}>
                                <input className="form-control mb-4" name="timeStart" value={this.state.timeStart} onChange={this.handleChangeTime.bind(this)}></input>
                            </div>
                            <div className="col">
                                {this.state.timeError &&
                                    <div className="text-danger">Ongeldige tijd opgegeven</div>
                                }

                            </div>

                        </div>
                    }


                    <div className="accordion" >
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className={this.state.accordionMain === "devices" ? "accordion-button" : "accordion-button collapsed"} type="button" onClick={p => this.selectAccordionMain("devices")}>
                                    Apparatuur
                                </button>
                            </h2>
                            <div className={this.state.accordionMain === "devices" ? "accordion-collapse collapse show" : "accordion-collapse collapse"}>
                                <div className="accordion-body">
                                    <div className="row">
                                        <div className="col-lg-7">
                                            {(this.state.enableSave ||
                                                (!this.state.enableSave && this.state.pa.length > 0)) &&
                                                <h4>Personenalarm</h4>
                                            }

                                            {this.state.pa.length > 0 && <>
                                                {paHeader}
                                                {pa}
                                            </>}

                                            {(this.state.pa.length === 0) &&
                                                this.state.enableSave && <div className="row">
                                                    <div className="col text-end">Toevoegen KEK/Serie-nr</div>
                                                    <div className="col" style={{ maxWidth: "120px" }}><input className="form-control" name="paInput" value={this.state.paInput} onChange={this.handleChange.bind(this)} /></div>
                                                    <div className="col-12 col-md-3">
                                                        <div className="dropdown">
                                                            <button className="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                toevoegen
                                                            </button>
                                                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                <button className="dropdown-item" onClick={() => this.addPa("bykek")}>op KEK</button>
                                                                <button className="dropdown-item" onClick={() => this.addPa("byserialnumber")}>op serie-nr</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            <div className="mb-4">

                                                {(this.state.enableSave ||
                                                    (!this.state.enableSave && this.state.sk.length > 0)) &&
                                                    <h4 className="mt-4">Toegangsbeheer</h4>
                                                }

                                                {this.state.sk.length > 0 && <>
                                                    {skHeader}
                                                    {sk}
                                                </>}
                                                {this.props.changes.state.equipmentAdded.filter(p => p.item && p.item.isHomeAccess).length > 0 &&
                                                    // we have added "woning toegang"
                                                    <>
                                                        <div className="row">
                                                            <div className="col-md-2">

                                                            </div>
                                                            <div className="col">
                                                                Sleutel in kluis geplaatst
                                                            </div>
                                                            <div className="col">
                                                            {/* warning do not use === here :  important to compare with a string value */}
                                                            <label className="me-4">
                                                            <input type="radio" checked={parseInt(this.state.keyPlaced) === 1} className="me-1" value={1}
                                                                name="keyPlaced" onChange={this.handleChange.bind(this)} />
                                                            N.v.t.</label>

                                                            <label className="me-4">
                                                            <input type="radio" checked={parseInt(this.state.keyPlaced) === 2} className="me-1"  value={2}
                                                                name="keyPlaced" onChange={this.handleChange.bind(this)}  />
                                                            Ja</label>

                                                            <label>
                                                            <input type="radio" checked={parseInt(this.state.keyPlaced) === 3} className="me-1"  value={3}
                                                                name="keyPlaced"  onChange={this.handleChange.bind(this)}  />
                                                            Nee</label>
                                                                
                                                            </div>
                                                            <div className="col-3">

                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col"></div>
                                                            <div className="col">
                                                                
                                                                {(this.state.keyPlaced===null || this.state.keyPlaced === "") &&
                                                                    <div className="row" >
                                                                        <div className="col"></div>
                                                                        <div className="col-8 text-danger ">
                                                                            Er moet worden aangegeven of de sleutel is achtergelaten.
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className="col"></div>
                                                        </div>
                                                    </>
                                                }

                                                {this.state.enableSave && <div className="row mt-2">
                                                    <div className="col text-end">Toevoegen KEK/Serie-nr</div>
                                                    <div className="col" style={{ maxWidth: "120px" }}><input className="form-control" name="skInput" value={this.state.skInput} onChange={this.handleChange.bind(this)} /></div>
                                                    <div className="col-12 col-md-3">
                                                        <div className="dropdown">
                                                            <button className="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                toevoegen
                                                            </button>
                                                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                <button className="dropdown-item" onClick={() => this.addSk("bykek")}>op KEK</button>
                                                                <button className="dropdown-item" onClick={() => this.addSk("byserialnumber")}>op serie-nr</button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>}
                                            </div>



                                            {!this.state.enableSave && <React.Fragment>
                                                <h4 className="mt-4">Meldbankcode</h4>
                                                <div className="row">
                                                    <div className="col"></div>
                                                    <div className="col-2">
                                                        {this.state.mbcode1}
                                                    </div>
                                                    <div className="col-3">
                                                        <span className="link clickable" onClick={() => {this.copyClipboard(this.state.mbcode2)}} >
                                                            {this.state.mbcode2} 
                                                        </span>
                                                    </div>
                                                    <div className="col-3">

                                                    </div>

                                                </div>
                                            </React.Fragment>}

                                            {this.state.enableSave && this.pa.length > 0 && <React.Fragment>
                                                <h4 className="mt-4">Installatiegegevens</h4>

                                                {this.props.changes.state.equipmentAdded.find(p => !p.item.isMobile && !p.item.isHomeAccess) &&
                                                    <>
                                                        <div className="row">
                                                            <div className="col text-end mt-2">Soort aansluiting:</div>
                                                            <div className="col-5">
                                                                <select className="form-control" name="pstnInstalled" value={this.state.pstnInstalled} onChange={this.handleChangeBool.bind(this)}>
                                                                    {this.state.pstnInstalled === "" &&
                                                                        <option value="">[maak een keuze]</option>
                                                                    }
                                                                    <option value={true}>PSTN</option>
                                                                    <option value={false}>overig</option>
                                                                </select>
                                                            </div>
                                                            <div className="col-3"></div>
                                                        </div>
                                                        {this.state.pstnInstalled === "" &&
                                                            <div className="row" >
                                                                <div className="col"></div>
                                                                <div className="col-8 text-danger ">
                                                                    Er moet aangegeven worden of er PSTN wordt gebruikt.
                                                                </div>

                                                            </div>

                                                        }
                                                    </>
                                                }

                                                <div className="row mt-2">
                                                    <div className="col text-end">Meldcentrale:</div>
                                                    <div className="col-5">
                                                        {this.state.emergencyCenter}
                                                    </div>
                                                    <div className="col-3 mt-2">

                                                    </div>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col text-end">
                                                        Meldbankcode:
                                                    </div>
                                                    <div className="col-5">
                                                        {this.state.mbcode1} - 

                                                        {this.state.isExchange && 
                                                            <>    {this.state.mbcode2}</>
                                                        }

                                                        {!this.state.isExchange && 
                                                        <>
                                                            <span className="link clickable" onClick={() => {this.copyClipboard(this.state.mbcode2)}} >
                                                                {this.state.mbcode2}
                                                            </span>
                                                        </>
                                                        }

                                                        
                                                        
                                                        </div>
                                                    
                                                        <div className="col-3">
                                                    { !this.state.isExchange  && 
                                                    <>
                                                        {!(this.changes.state.mbcode1 || this.changes.state.mbcode2) &&
                                                            // no changes made yet
                                                            <>
                                                                <button className="btn btn-danger" onClick={p => this.showDeviceCodeList()}>wijzigen</button>
                                                            </>
                                                        }

                                                        {(this.changes.state.mbcode1 || this.changes.state.mbcode2) &&
                                                            (this.state.mbcode1 !== this.bp.reportingCenterCode1 || this.state.mbcode2 !== this.bp.reportingCenterCode2) &&
                                                            // changes have been made
                                                            <>

                                                                <button className="btn btn-danger" onClick={p => this.resetMbCode()}>reset</button>
                                                            </>
                                                        }
                                                        </>
                                                    }
                                                    </div>

                                                </div>
                                                {this.state.mbcode2 === "" &&
                                                    <div className="row" >
                                                        <div className="col"></div>
                                                        <div className="col-8 text-danger ">
                                                            Er moet een MB-code opgegeven worden bij installatie van een personenalarm.
                                                        </div>

                                                    </div>
                                                }

                                                
                                                {this.state.mbcode2 !== "" && this.state.emergencyCenter === "GEEN" &&
                                                    <div className="row" >
                                                        <div className="col"></div>
                                                        <div className="col-8 text-danger ">
                                                            Er moet een meldcentrale opgegeven worden als er een meldbank code is.
                                                        </div>

                                                    </div>
                                                }

                                                {this.state.protocol && <div className="row mt-2">
                                                    <div className="col text-end ">Protocol:</div>
                                                    <div className="col-5">
                                                        {this.state.protocol}
                                                    </div>
                                                    <div className="col-3">

                                                    </div>
                                                </div>
                                                }
                                                {this.state.isExchange &&
                                                <>
                                                <h4>Omruiling naar:</h4>
                                                

                                                {this.props.current.serviceCall.changeArcCode!==null && <div className="row mt-2">
                                                    <div className="col text-end ">Meldcentrale:</div>
                                                    <div className="col-5">
                                                        {this.props.current.serviceCall.changeArcCode}
                                                    </div>
                                                    <div className="col-3">

                                                    </div>
                                                </div>
                                                }
                                                {this.props.current.serviceCall.changeDeviceCode2!==null && <div className="row mt-2">
                                                    <div className="col text-end ">Meldbankcode:</div>
                                                    <div className="col-5">
                                                        {this.state.changeDeviceCode1} 
                                                        <span className="link clickable" onClick={() => {this.copyClipboard(this.props.current.serviceCall.changeDeviceCode2)}} >
                                                            {this.props.current.serviceCall.changeDeviceCode2}
                                                        </span>
                                                    </div>
                                                    <div className="col-3">

                                                    </div>
                                                </div>
                                                }
                                                </>
                                            }
                                            </React.Fragment>}
                                        </div>
                                        <div className="col-lg-5">
                                            <h4>Accessoires</h4>
                                            <Accessories bon={this.props.current} changes={this.changes} enableSave={this.state.enableSave}></Accessories>


                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {this.props.current.orders != null && this.props.current.orders.length > 0 &&
                            <div className="accordion-item">

                                <h2 className="accordion-header">
                                    <button className={this.state.accordionMain === "additional" ? "accordion-button" : "accordion-button collapsed"} type="button" onClick={p => this.selectAccordionMain("additional")}>
                                        Additionele producten
                                    </button>
                                </h2>
                                <div className={this.state.accordionMain === "additional" ? "accordion-collapse collapse show" : "accordion-collapse collapse"} >
                                    <div className="accordion-body">
                                        <Products orders={this.props.current.orders}
                                            selectableProducts={this.props.selectableProducts}
                                            changes={this.changes}
                                            enableSave={this.state.enableSave}
                                            resolutionUpdated={this.resolutionUpdated.bind(this)}></Products>

                                    </div>
                                </div>
                            </div>
                        }

                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className={this.state.accordionMain === "work" ? "accordion-button" : "accordion-button collapsed"} type="button" onClick={p => this.selectAccordionMain("work")}>
                                    Werkzaamheden
                                </button>
                            </h2>
                            <div className={this.state.accordionMain === "work" ? "accordion-collapse collapse show" : "accordion-collapse collapse"} >
                                {!this.state.enableSave &&
                                    <div className="accordion-body">

                                        <div className="row">
                                            <div className="col">
                                                Werkzaamheden: <br />
                                                <div className="form-control bg-light" disabled>
                                                    {this.state.resolution}
                                                </div>

                                            </div>
                                        </div>

                                        <div className="row mt-2 mb-2">
                                            <div className="col">
                                                <CheckItem value={this.state.linetest} label={"Telefoon/IP verbindingstest"}></CheckItem>
                                                <CheckItem value={this.state.alarmcall} label={"Alarm oproep"}></CheckItem>
                                                <CheckItem value={this.state.validdata} label={"Juiste gegevens"}></CheckItem>
                                            </div>
                                            <div className="col">
                                                Test seconden:  {this.state.testSeconds}
                                            </div>
                                        </div>


                                    </div>

                                }
                                {this.state.enableSave &&
                                    <div className="accordion-body">


                                        <div className="row">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col-auto">
                                                        <select onChange={this.selectPredefinedText.bind(this)}>
                                                            {predefinedTextOptions}
                                                        </select></div>
                                                    <div className="col"> <i className="fa-solid fa-triangle-exclamation text-danger"></i> LET OP: Onderstaande tekst wordt weergegeven op de bon voor de klant</div>
                                                </div>

                                                <textarea className="form-control mt-2" name="resolution" style={{ height: "100px", minHeight: "100px" }}
                                                    onFocus={this.textareaFocus.bind(this)}
                                                    onChange={this.handleChange.bind(this)} value={this.state.resolution ?? ""}></textarea>


                                            </div>

                                            <div className="col ms-4">
                                                {this.state.pa.length === 0 && <div className="mb-4">
                                                    <i className="fa-solid fa-circle-info"></i> Test reactietijd alarmcentrale alleen mogelijk indien personenalarm geinstalleerd.
                                                </div>}
                                                {this.state.pa.length > 0 && <>
                                                    <div className="mb-4">
                                                        Test reactietijd alarmcentrale
                                                        <button className="btn btn-success ms-4" onClick={this.openTest.bind(this)}>Open</button>

                                                        {
                                                            (this.state.testStarted || this.state.testSeconds > 0) &&
                                                            <span className="ms-4">{this.state.testSeconds} seconden</span>
                                                        }

                                                    </div>
                                                    <div>
                                                        <label><input className="me-2" type="checkbox" name="linetest" checked={this.state.linetest} onChange={this.handleCheckbox.bind(this)}></input>
                                                            <span className="checkboxLabel">Telefoon/IP verbindingstest</span> </label><br />
                                                        <label><input className="me-2 mt-4" type="checkbox" name="alarmcall" checked={this.state.alarmcall} onChange={this.handleCheckbox.bind(this)}></input>
                                                            <span className="checkboxLabel">Alarm oproep</span></label><br />
                                                        <label><input className="me-2 mt-4" type="checkbox" name="validdata" checked={this.state.validdata} onChange={this.handleCheckbox.bind(this)}></input>
                                                            <span className="checkboxLabel">Juiste gegevens</span></label>
                                                    </div>



                                                </>

                                                }

                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>

                    </div>





                </React.Fragment>
            }
            <Toaster />
        </div>
    }

}



export default Actions;